import { render, staticRenderFns } from "./VisualizarGrupoNotificacaoDialog.vue?vue&type=template&id=217e39c4&scoped=true"
import script from "./VisualizarGrupoNotificacaoDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarGrupoNotificacaoDialog.vue?vue&type=script&lang=js"
import style0 from "./VisualizarGrupoNotificacaoDialog.vue?vue&type=style&index=0&id=217e39c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217e39c4",
  null
  
)

export default component.exports